import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import ControleAcces from './controle-acces';

const Routes = ({ match }) => (
  <Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleId/:anneeScolaireId`} component={ControleAcces} />
    <ErrorBoundaryRoute exact path={match.url} component={ControleAcces} />
  </Switch>
);
export default Routes;
